import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useL10n } from '@uplift/hooks';
import { InfoRow } from '../InfoRow';
import { InfoSection } from '../InfoSection';
import { ContactInfoRow } from '../ContactInfoRow';


const useStyles = makeStyles()(theme => ({
  disabledLabel: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  }
}));


export type SectionContactsProps = {
  loading: boolean;
  isSignUpIncomplete?: boolean;
  patientDetails?: {
    email: string;
    phone: string;
  };
};

export const SectionContacts: React.FC<SectionContactsProps> = ({ loading, isSignUpIncomplete, ...props }) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  const phoneContact = React.useMemo(() => {
    if (isSignUpIncomplete) {
      return (
        <InfoRow label={l10n.sessions.detailsModal.mobile}>
          <Typography className={classes.disabledLabel}>
            {l10n.sessions.detailsModal.phoneWillBeAvailableAfterCreatesAccount}
          </Typography>
        </InfoRow>
      );
    }

    return (
      <ContactInfoRow
        type="phone"
        label={l10n.sessions.detailsModal.mobile}
        value={props.patientDetails?.phone}
        loading={loading}
        loadingWidth="120px"
      />
    );
  }, [ l10n, isSignUpIncomplete, props.patientDetails, loading, classes ]);


  return (
    <InfoSection title={l10n.sessions.detailsModal.contactInformation}>
      {phoneContact}
      <ContactInfoRow
        type="email"
        label={l10n.sessions.detailsModal.email}
        value={props.patientDetails?.email}
        loading={loading}
        loadingWidth="140px"
        mt={1}
      />
    </InfoSection>
  );
};
